import BaselineStyles from '@bowtie-ins/bowkit/BaselineStyles';
import { css, Global } from '@emotion/react';
import React from 'react';

export const IframeBaselineStyles: React.FC = () => {
  return (
    <>
      <BaselineStyles />
      <Global
        styles={css`
          body {
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0) 50%,
              rgba(255, 255, 255, 1) 75%,
              rgba(255, 255, 255, 1) 100%
            );
          }
        `}
      />
    </>
  );
};
